@if (icon() || description()) {
  <div
    class="flex flex-col items-center justify-center text-center gap-4 p-8"
    [attr.data-testid]="testId() || null"
  >
    @if (icon()) {
      <i [class]="icon() + ' text-6xl! text-primary'"></i>
    }
    <h3 class="text-lg font-semibold text-gray-400 mb-2" [attr.data-testid]="textTestId() || null">
      {{ label() | transloco }}
    </h3>
    @if (description()) {
      <p class="text-gray-500 max-w-md mx-auto">{{ description() | transloco }}</p>
    }
    <ng-content />
  </div>
} @else {
  <div
    class="flex justify-center items-center py-12 text-3xl"
    [attr.data-testid]="testId() || null"
  >
    <p class="text-gray-300" [attr.data-testid]="textTestId() || null">{{ label() | transloco }}</p>
  </div>
}
